import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import DateOrMonthPicker from 'Components/ComponentLibrary/Molecules/DateOrMonthPicker';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import HelperText from 'Components/UI/Meta/MetaControl/HelperText';
import moment from 'moment';

const styles = () => ({
  root: {},
  helperText: {
    marginLeft: 14,
  },
});

const StartEndAndMonths = ({
  className,
  classes,
}) => {
  const { resource, handleChange } = useMetaLayoutContext();
  const endDateMetaField = resource.meta().field('endDate');
  const startDate = resource.attr('startDate');
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <SurveyStepHeader
        className={classes.header}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <MetaControlField attr={'startDate'} />
      <MetaControlField attr="startDateConfidenceLevel" />
      <Box test={'attr-endDate'}>
        <DateOrMonthPicker
          value={resource.attr('endDate')}
          onChange={(newVal) => {
            handleChange('endDate', newVal);
            // Also need to update monthsToComplete
            const monthsToComplete = moment(newVal).diff(moment(startDate), 'months');
            handleChange('monthsToComplete', monthsToComplete);
          }}
          label={resource.meta().field('endDate').attr('prompt')}
          startDate={startDate}
        />
        <Box className={classes.helperText}>
          <HelperText metaField={endDateMetaField} />
        </Box>
      </Box>
      <MetaControlField attr="endDateConfidenceLevel" />
    </Box>
  );
};

StartEndAndMonths.defaultProps = {
  className: '',
};

StartEndAndMonths.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StartEndAndMonths);
